import React from "react";

// Brand mark: red D + DriveTerrain wordmark (matches uploaded Loriento Inc artwork)
export default function BrandMark({ size = "md", showWordmark = true, className = "" }) {
  const sizes = {
    sm: { box: "w-7 h-7", text: "text-xs", word: "text-base" },
    md: { box: "w-9 h-9", text: "text-base", word: "text-lg" },
    lg: { box: "w-14 h-14", text: "text-2xl", word: "text-2xl" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-mark">
      <div className={`${s.box} bg-red-600 flex items-center justify-center text-white font-display font-extrabold leading-none shadow-sm`}
           style={{ borderRadius: "10% 10% 10% 10% / 12% 12% 12% 12%" }}>
        <span className={s.text}>D</span>
      </div>
      {showWordmark && (
        <span className={`font-display font-extrabold tracking-tight ${s.word} text-foreground`}>
          Drive<span className="text-foreground">Terrain</span>
        </span>
      )}
    </div>
  );
}
